import { Routes, Route } from "react-router-dom";

import styles from "../common/Page.module.css";
import SideMenuStatic from "Page/common/SideMenuStatic";
import SupportMain from "./Content/SupportMain";
import SupportBoard from "./Content/Support/SupportBoard";
import SupportArticle from "./Content/Support/SupportArticle";
import QnaBoard from "./Content/Qna/QnaBoard";
import QnaArticle from "./Content/Qna/Article/QnaArticle";
import QnaPost from "./Content/Qna/Post/QnaPost";

export default function SupportPage() {
  const menus = [
    { title: "공지사항", to: "/support/category/1" },
    { title: "자료실", to: "/support/category/2" },
    { title: "Q&A 게시판", to: "/support/qna/articles" },
  ];

  return (
    <div className={styles.Page}>
      <div className={styles.ContentContainer}>
        <Routes>
          <Route exact path="/" element={<SupportMain />} />
          <Route path="/category/:category_id" element={<SupportBoard />} />
          <Route path="/article/:article_id" element={<SupportArticle />} />
          <Route path="/qna/articles" element={<QnaBoard />} />
          <Route path="/qna/article/:article_id" element={<QnaArticle />} />
          <Route path="/qna/post" element={<QnaPost />} />
        </Routes>
      </div>
    </div>
  );
}
